import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { event } from '@uhg-abyss/web/tools/event';
import { storage } from '@uhg-abyss/web/tools/storage';
import { useModal } from 'src/state/modal';
import { useWindowSize } from '@sde/widgets-core/src/tools/useWindowSize';
import { DropdownContent } from './DropdownContent';

const StyledFlexDiv = styled('div', {
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  fontFamily: 'UHCSans, Arial, sans-serif',
});

export const AppNavItem = ({
  key,
  name,
  href,
  exitLink,
  isBlocked,
  type,
  isDropdown,
  dataTestId,
}) => {
  const { toggleModal } = useModal.actions();
  const { width } = useWindowSize();

  const openPermissionsModal = () => {
    toggleModal({ key: 'permissions', isOpen: true, toolName: name });
  };

  const trimTitleLength = (title) => {
    const maxTitleLength = 20;

    if (title.length > maxTitleLength && width >= 984 && width <= 1055) {
      return `${title.substring(0, maxTitleLength - 3)}...`;
    }
    return title;
  };

  const openNavMenuExitLinkModal = () => {
    const storageKey = `ExitLink-${exitLink.to}`;
    const allowModalOpen =
      exitLink.modalContent && !storage.local.get(storageKey);
    if (allowModalOpen) {
      toggleModal({
        key: 'NavMenuExitLink',
        isOpen: true,
        toolName: name,
        data: {
          ...exitLink,
          storageKey,
        },
      });
    } else {
      window.open(exitLink.to, '_blank');
    }
  };

  const handleClick = () => {
    event('NAVIGATION_CLICK', { name });
  };

  if (isBlocked) {
    return {
      title: <div data-testid={dataTestId}>{name}</div>,
      onClick: openPermissionsModal,
    };
  }
  if (exitLink) {
    return {
      title: (
        <StyledFlexDiv data-testid={dataTestId}>
          {name}
          <IconMaterial size="16px" icon="launch" color="$interactive1" />
        </StyledFlexDiv>
      ),
      onClick: openNavMenuExitLinkModal,
    };
  }
  if (type === 'dropdown' || isDropdown) {
    return {
      title: <div data-testid={dataTestId}>{trimTitleLength(name)}</div>,
      content: <DropdownContent dropdownKey={key} />,
    };
  }
  // type === 'link'
  return {
    title: <div data-testid={dataTestId}>{trimTitleLength(name)}</div>,
    href,
    onClick: () => handleClick(),
  };
};

AppNavItem.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  key: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  href: PropTypes.string,
  exitLink: PropTypes.shape({
    to: PropTypes.string,
    modalContent: PropTypes.string,
  }),
  isBlocked: PropTypes.bool,
  type: PropTypes.string.isRequired,
  isDropdown: PropTypes.bool,
  dropdownContent: PropTypes.shape({
    contents: PropTypes.shape({}),
    params: PropTypes.shape({}),
  }),
  dataTestId: PropTypes.string,
};

AppNavItem.defaultProps = {
  href: '',
  exitLink: null,
  isBlocked: false,
  isDropdown: false,
  dropdownContent: {},
  dataTestId: null,
};
